import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { environment } from '../environments/environment';
import { provideApollo } from 'apollo-angular';
import { Router, provideRouter } from '@angular/router';
import { ROUTES } from './app.routes';
import { UserProfileService } from './services/user-profile.service';
import { MENU_STATE_SERVICE, USER_PROFILE_LOADER } from 'ngx-register-base';
import { MenuStateService } from './services/menu-state.service';
import { prizmIconsProvideOldNameTransformer } from '@prizm-ui/icons';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideEventPlugins } from '@taiga-ui/event-plugins';
import { initKeycloak } from './keycloak/keycloak-init.factory';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { TUI_LANGUAGE, TUI_RUSSIAN_LANGUAGE } from '@taiga-ui/i18n';
import { of } from 'rxjs';
import { TraceService, createErrorHandler } from '@sentry/angular';

export const appConfig: ApplicationConfig = {
  providers: [
    KeycloakService,
    UserProfileService,
    {
      provide: APP_INITIALIZER,
      useFactory: initKeycloak,
      deps: [UserProfileService],
      multi: true,
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(ROUTES),
    provideAnimations(),
    provideEventPlugins(),
    provideHttpClient(withInterceptorsFromDi()),
    provideApollo(() => {
      const httpLink = inject(HttpLink);

      return {
        link: httpLink.create({ uri: environment.api.graphql }),
        cache: new InMemoryCache(),
      };
    }),
    importProvidersFrom(KeycloakAngularModule),
    { provide: USER_PROFILE_LOADER, useExisting: UserProfileService },
    { provide: MENU_STATE_SERVICE, useExisting: MenuStateService },
    prizmIconsProvideOldNameTransformer(),
    { provide: TUI_LANGUAGE, useValue: of(TUI_RUSSIAN_LANGUAGE) },
    {
      provide: ErrorHandler,
      useValue: createErrorHandler(),
    },
    {
      provide: TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [TraceService],
      multi: true,
    },
  ],
};
